import {
  TboAuditBodyUrlResponseSchema,
  TboAuditListResponseSchema,
  type TboAuditListQuery,
  type TboAuditListResponse,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * TBO API audit log (admin-only viewer). Every response is validated with the
 * shared Zod schema so a server change can't sneak past the UI types. The heavy
 * request/response bodies live in S3 and are fetched on demand via a short-lived
 * presigned URL (`getTboAuditBodyUrl`).
 */

export const listTboAudit = async (query: TboAuditListQuery): Promise<TboAuditListResponse> => {
  const { data } = await apiClient.get<unknown>('/tbo-audit', { params: query });
  return TboAuditListResponseSchema.parse(data);
};

/** Returns a short-lived presigned GET URL for the gzipped full body in S3. */
export const getTboAuditBodyUrl = async (id: string): Promise<string> => {
  const { data } = await apiClient.get<unknown>(`/tbo-audit/${id}/body`);
  return TboAuditBodyUrlResponseSchema.parse(data).url;
};
